import { useState, useEffect, useRef } from "react";
import style from "../../../styles/pujaDetails.module.css";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
function ScrollNavbarAB({
  scrollToSection,
  activeLink,
  setActiveLink,
  data
}) {
  const {
    t
  } = useTranslation();
  const [prevScrollY, setPrevScrollY] = useState(0);
  const [isSticky, setIsSticky] = useState(false);
  const navbarRef = useRef(null);
  const onMobile = useMediaQuery("(max-width:768px)");
  const refs = {
    about: useRef(null),
    sevas: useRef(null),
    benefits: useRef(null),
    process: useRef(null),
    youtubeVideo: useRef(null),
    review: useRef(null),
    faq: useRef(null)
  };
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      let navbar = document.getElementById("navbar");
      // console.log("arnab navbar", navbar);
      var navBar = document.getElementById("navBar");
      // console.log("arnab navBar", navBar);
      var topContainer = document.getElementById("topContainer");
      // console.log("arnab topContainer", topContainer);
      if (!navbar || !navBar) return;
      var navSticky = navBar.offsetTop;
      var navHeight = navbar.clientHeight;
      var scrollNavHeight = navBar.clientHeight;
      var topContainerSticky = 0;
      var topContainerHeight = 0;
      if (topContainer) {
        topContainerHeight = topContainer.clientHeight;
        topContainerSticky = topContainer.getBoundingClientRect().top;
      }
      if (currentScrollY > prevScrollY) {
        // console.log(
        //   "scrolling down",
        //   window.scrollY,
        //   navSticky,
        //   navHeight,
        //   window.pageYOffset >= navSticky
        // );
        if (window.pageYOffset >= navSticky - navHeight && navbar) {
          setIsSticky(true);
          if (currentScrollY > prevScrollY) {
            navbar.style.boxShadow = "none"; // Change the value here
            navbar.style["box-shadow"] = "none"; // Change the value here
          } else {
            navbar.style.boxShadow = "0px 1px 10px rgba(0, 0, 0, 0.2)";
          }
        } else {
          setIsSticky(false);
          if (navBar) {
            navBar.style.transition = "box-shadow 0.3s ease-in-out";
          }
          if (currentScrollY > prevScrollY && navbar) {
            navbar.style.boxShadow = "0px 1px 10px rgba(0, 0, 0, 0.2)";
          }
        }
      } else {
        // console.log("scrolling up");

        if (topContainerHeight + topContainerSticky >= navHeight + scrollNavHeight && navbar) {
          setIsSticky(false);
          if (currentScrollY > prevScrollY) {
            navbar.style.boxShadow = "none"; // Change the value here
            navbar.style["box-shadow"] = "none"; // Change the value here
          } else {
            navbar.style.boxShadow = "0px 1px 10px rgba(0, 0, 0, 0.2)";
          }
        } else {
          setIsSticky(true);
          if (navBar) {
            navBar.style.transition = "box-shadow 0.3s ease-in-out";
          }
          if (window.scrollY > 0 && navbar) {
            navbar.style.boxShadow = "0px 1px 10px rgba(0, 0, 0, 0.2)";
          }
        }
      }
      setPrevScrollY(currentScrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollY]);
  useEffect(() => {
    if (onMobile) {
      // const container = navbarRef.current;
      // if (!container) return;

      const activeLinkElement = refs[activeLink]?.current;
      if (activeLinkElement) {
        // const xCoordinate = activeLinkElement.getBoundingClientRect().left;
        // const xOffset = -20;

        // container.scrollTo({
        //   left: xCoordinate + 200 + xOffset,
        //   behavior: "smooth",
        // });
        const xCoordinate = activeLinkElement.getBoundingClientRect().left;
        const xOffset = -20;
        navbarRef.current.scrollTo({
          left: xCoordinate + xOffset,
          behavior: "smooth"
        });
      }
    }
  }, [activeLink, onMobile]);
  const navbarStyles = {
    position: isSticky ? "fixed" : "sticky",
    boxShadow: isSticky ? "0px 4px 6px rgba(0, 0, 0, 0.2)" : "0px 2px 4px rgba(0, 0, 0, 0.1)",
    borderBottom: isSticky ? "none" : "1px solid rgba(0, 0, 0, 0.1)",
    borderTop: isSticky ? "none" : "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: "2px",
    padding: !onMobile ? "10px 140px" : "10px 17px",
    color: "var(--text_primary)",
    background: isSticky ? "#ffffffbf" : "white",
    zIndex: 999,
    overflowX: "auto",
    whiteSpace: "nowrap",
    top: isSticky ? onMobile ? `55px` : "65px" : "auto",
    left: isSticky ? "0" : "auto",
    width: isSticky ? "100%" : "auto",
    backdropFilter: isSticky ? "blur(5px)" : "none",
    transition: "box-shadow 0.5s ease-in-out"
    // maxWidth: "1600px",
  };
  return <div id="navBar" className={style.scrollWidth2} style={navbarStyles} ref={navbarRef} data-sentry-component="ScrollNavbarAB" data-sentry-source-file="ScrollNav.jsx">
      <div className={`${style.navList} ${isSticky ? style.stickyNavList : ""}`}>
        <div className={style.scrollItem}>
          <div ref={refs.about} onClick={e => {
          e.preventDefault();
          scrollToSection("about");
        }} className={activeLink === "about" ? style.active : ""}>
            {t("about-puja")}
          </div>
          <div className={activeLink === "about" ? style.NavLine : null}></div>
        </div>

        <div className={style.scrollItem}>
          <div ref={refs.process} onClick={e => {
          e.preventDefault();
          scrollToSection("process");
        }} className={activeLink === "process" ? style.active : null}>
            {t("puja-process")}
          </div>
          <div className={activeLink === "process" ? style.NavLine : null}></div>
        </div>

        {data.EventBenefitRelations.length > 0 && <div className={style.scrollItem}>
            <div ref={refs.benefits} onClick={e => {
          e.preventDefault();
          scrollToSection("benefits");
        }} className={activeLink === "benefits" ? style.active : ""}>
              {t("benefits")}
            </div>
            <div className={activeLink === "benefits" ? style.NavLine : null}></div>
          </div>}

        <div className={style.scrollItem}>
          <div ref={refs.sevas} onClick={e => {
          e.preventDefault();
          scrollToSection("sevas");
        }} className={activeLink === "sevas" ? style.active : ""}>
            {t("pujas")}
          </div>
          <div className={activeLink === "sevas" ? style.NavLine : null}></div>
        </div>

        {onMobile && data.sampleYoutube && <div className={style.scrollItem}>
            <div ref={refs.youtubeVideo} onClick={e => {
          e.preventDefault();
          scrollToSection("youtubeVideo");
        }} className={activeLink === "youtubeVideo" ? style.active : null}>
              {t("puja-video")}{" "}
            </div>
            <div className={activeLink === "youtubeVideo" ? style.NavLine : null}></div>
          </div>}
        {data.ReviewModels?.length >= 5 && <div className={style.scrollItem}>
            <div ref={refs.review} onClick={e => {
          e.preventDefault();
          scrollToSection("review");
        }} className={activeLink === "review" ? style.active : null}>
              {t("reviews")}
            </div>
            <div className={activeLink === "review" ? style.NavLine : null}></div>
          </div>}
        {data.Faqs.length > 0 && <div className={`${style.scrollItem} ${onMobile && style.navFaq}`}>
            <div ref={refs.faq} onClick={e => {
          e.preventDefault();
          scrollToSection("faq");
        }} className={`${activeLink === "faq" ? style.active : null} `}>
              {t("faqs")}
            </div>
            <div className={activeLink === "faq" ? style.NavLine : null}></div>
          </div>}
      </div>
    </div>;
}
export default ScrollNavbarAB;